module.exports = __webpack_public_path__ + "static/media/ipdata.a0b11088.png";